// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CartVendorGroup_wrap__jwznM","vendorLink":"CartVendorGroup_vendorLink__lDPa9"};